/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({
    "data": {
      "zh": {
        "categories": {
          "cardinal": ["other"],
          "ordinal": ["other"]
        },
        "fn": function fn(n, ord) {
          return 'other';
        }
      }
    },
    "aliases": {
      "zh-CN": "zh-Hans-CN",
      "zh-guoyu": "zh",
      "zh-hakka": "hak",
      "zh-HK": "zh-Hant-HK",
      "zh-min-nan": "nan",
      "zh-MO": "zh-Hant-MO",
      "zh-SG": "zh-Hans-SG",
      "zh-TW": "zh-Hant-TW",
      "zh-xiang": "hsn",
      "zh-min": "nan-x-zh-min"
    },
    "parentLocales": {
      "zh-Hant-MO": "zh-Hant-HK"
    },
    "availableLocales": ["zh"]
  });
}